import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4148e90a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4148e90a')) {
      api.createRecord('4148e90a', component.options)
    } else {
      api.reload('4148e90a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4148e90a&", function () {
      api.rerender('4148e90a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/repair/proprietorAudit/index.vue"
export default component.exports